import { GeneralError, ResetPasswordUseCase } from '51trips-frontend-core'
import classNames from 'classnames'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { take } from 'rxjs/operators'

import CheckCircleFullIcon from '../../assets/icons/check-circle-full.svg?react'
import { Button } from '../../components/Button'
import { Input } from '../../components/Input'
import { AuthenticationRepository } from '../../repositories/AuthenticationRepository'
import { userReadableDescription } from '../../utils/UserReadableDescription'

const resetPasswordUseCase = new ResetPasswordUseCase(new AuthenticationRepository())

export const ForgottenPasswordPage: React.FC = () => {
  /// i18n
  const { t } = useTranslation()

  /// States
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)

  /// Actions

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    setIsSubmitting(true)

    resetPasswordUseCase
      .resetPassword(email)
      .pipe(take(1))
      .subscribe({
        next: () => {
          setIsSubmitted(true)
        },
        error: (error: GeneralError) => {
          userReadableDescription(error)
          setIsSubmitting(false)
        }
      })
  }

  /// Render

  return (
    <>
      {isSubmitted ? (
        <div className="text-center space-y-5 px-4">
          <CheckCircleFullIcon className="size-10 mx-auto" />

          <h2 className="text-xl font-medium">
            {t('forgottenPassword.successTitle', { ns: 'auth' })}
          </h2>

          <p>{t('forgottenPassword.checkYourEmail', { ns: 'auth' })}</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <h2 className="font-medium text-xl">{t('forgottenPassword.title', { ns: 'auth' })}</h2>

          <p>{t('forgottenPassword.description', { ns: 'auth' })}</p>

          <Input
            type="email"
            required
            value={email}
            onChange={handleEmailChange}
            placeholder={t('forgottenPassword.emailInput.placeholder', { ns: 'auth' })}
            block
          />

          <Button
            variant="primary"
            type="submit"
            label={t('forgottenPassword.recoverPassword', { ns: 'auth' })}
            disabled={isSubmitting}
          />
        </form>
      )}

      <div className={classNames('mt-4', { 'text-center': isSubmitted })}>
        <Link to="/auth/login" className="underline">
          {t('forgottenPassword.backToLogin', { ns: 'auth' })}
        </Link>
      </div>
    </>
  )
}
